import client from './client';

export async function listActivityLogs(params) {
  const { data } = await client.get('/activity-logs', { params });
  return data.data; // Laravel paginator
}
